module.exports = __webpack_public_path__ + "images/emoji/ocean.8ffb4b225d36f3af1fac.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/ocean.png
// module id = V8sV
// module chunks = 14